import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../hooks'
import { getMockCalendarDayLoadAdvisory } from '../../CalendarDayLoad.mock'
import {
  getCalendarDayLoadAdvisoryText,
  getIsCalendarDayLoadCheckPending,
} from '../../CalendarDayLoad.utils'

export function useCalendarDayLoadAdvisory() {
  const { t } = useTranslation()

  const { handleAddWarningNotification } = useNotification()

  const checkRef = useRef(null)

  function handleChangeDayLoadCheck(check) {
    checkRef.current = check
  }

  function getHandleShowDayLoadAdvisory() {
    const check = checkRef.current

    return function handleShowDayLoadAdvisory(data, count) {
      if (getIsCalendarDayLoadCheckPending(check)) {
        // TODO: read only the write's own day_load_advisory once the backend
        // returns it (TM-01-13, TM-01-14, TM-01-48).
        const text = getCalendarDayLoadAdvisoryText({
          advisory:
            data?.day_load_advisory ?? getMockCalendarDayLoadAdvisory(check),
          count: count ?? check.requestIds.length,
          t,
        })

        if (text) {
          handleAddWarningNotification({
            text,
            title: t('Calendar.LoadCheckFailedKey'),
          })
        }
      }
    }
  }

  return { getHandleShowDayLoadAdvisory, handleChangeDayLoadCheck }
}
